import { render, staticRenderFns } from "./SurveyInsights.vue?vue&type=template&id=6c6dddc6&"
import script from "./SurveyInsights.vue?vue&type=script&lang=js&"
export * from "./SurveyInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c6dddc6')) {
      api.createRecord('6c6dddc6', component.options)
    } else {
      api.reload('6c6dddc6', component.options)
    }
    module.hot.accept("./SurveyInsights.vue?vue&type=template&id=6c6dddc6&", function () {
      api.rerender('6c6dddc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/SurveyInsights.vue"
export default component.exports